import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PillComponent } from '../components/pill/pill.component';
import { AutoComplete, AutoCompleteModule, Dropdown, DropdownModule } from 'primeng';
import { VmeCommonModule } from '../../../vme-common.module';
import { SelectItem } from 'primeng/api';
import { SupplierRiskManagementService } from '../../../services/supplier-risk-management.service';

@Component({
  selector: 'assigned-to',
  standalone: true,
  imports: [CommonModule, PillComponent, DropdownModule, AutoCompleteModule, VmeCommonModule],
  templateUrl: './assigned-to.component.html',
  styleUrls: ['./assigned-to.component.css'],
})
export class AssignedToComponent implements OnInit, OnChanges {
  constructor(private supplierRiskManagementService: SupplierRiskManagementService) {}
  async ngOnInit() {
    await this.loadUsers();
    this._assigneeId = this.assigneeId;
  }

  ngOnChanges(changes: any) {
    if (changes.assigneeId) {
      this._assigneeId = changes.assigneeId.currentValue;
    }
  }

  protected async loadUsers() {
    let res = await this.supplierRiskManagementService.getAssignees();
    this.users = res;
  }

  @Output() assignedUserChange: EventEmitter<SelectItem> = new EventEmitter<SelectItem>();

  @ViewChild('dropdown') dropdown: Dropdown;

  users: SelectItem[] = [];
  @Input() assigneeId: string;
  _assigneeId: string;
  get assignee() {
    return {
      label: this.users.find((x) => x.value === this._assigneeId)?.label,
      value: this._assigneeId,
    };
  }

  unassignUser() {
    this.assignedUserChange.emit(null);
  }
}
